<template>
  <div>
    <div class="title mt-5">
      <h3 class="d-flex justify-content-center header">
        {{$t('headers.hearing_test')}}
      </h3>
    </div>
    <div class="d-flex justify-content-center ml-2 ml-md-0 mr-2 mr-md-0 mb-3">
      <span class="header header-2">{{$t('headers.checkup')}}</span>
    </div>
    <div class="row m-0">
      <div class="col-md-3 d-none d-md-flex justify-content-center align-items-center">
        <img src="public/questionnaire.svg" alt="" class="questionnaire-icon">
      </div>
      <div class="col-md-6">
        <span class="header header-4 header-start header-secondary" style="color: rgb(65,65,65); font-weight: 600;">{{$t('landing.before_start_label')}}</span>
        <ol class="mt-3">
          <li v-for="recommendation in recommendations" :key="recommendation.id" class="instructions">
            <!-- <div class="recommendation-number mr-4">
              {{recommendation.id}}.
            </div> -->
            <div class="recommendation-text label.custom-label">
              {{recommendation.text}}
            </div>
          </li>
        </ol>
      </div>
      <div class="col-md-3 d-flex align-items-end justify-content-center justify-content-md-start">
        <button type="button" class="button primary" @click="$emit('continue')">{{$t('actions.start')}}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      recommendations: [
        {id: 1, text: this.$t('landing.recommendations.hearing_aids_user')},
        {id: 2, text: this.$t('landing.recommendations.quiet_environment')},
        {id: 3, text: this.$t('landing.recommendations.headphones')},
        {id: 4, text: this.$t('landing.recommendations.indicative')}
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.message {
  margin-top: 7.5rem !important;
  margin-bottom: 7.5rem !important;
}

ol {
  color: #6e6e6e;
  padding-left: 30px;
  li.instructions {
    font-size: 2rem;
    @media (max-width: 576px) { 
      font-size: 1.5rem;
    }
    .recommendation-text {
      font-size: 1.2rem;
      @media (max-width: 576px) { 
        font-size: 1.1rem;
      }
    }
  }
}

.recommendation-text {
  padding-bottom: 10px;
}

.recommendation-number {
  font-size: 2.5rem;
}

.questionnaire-icon {
  max-width: 150px;
}


</style>